import { getCmsSpecialFareOfferDetailAction } from "../../../Actions/LogicActions/CMSOffers/GetCmsSpecialFareOfferDetailAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { IOfferDiscoverParams } from "../../../Orchestrator/Types/Interface/ICMSOffers";

class OfferDetailInitStep extends StepFlow {
  get stepName() {
    return "OfferDetailInit_Step";
  }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on<IOfferDiscoverParams, void>({
        eventName: evtTree.CMSOffers.Detail.Get,
        handler: async ({ data }) => {
          if (data?.slug) {
            // This is old offer detail action, now replaced with special fare detail action
            // getCmsOfferDetailAction.setParams(data!);
            // getCmsOfferDetailAction.execute();
            getCmsSpecialFareOfferDetailAction.setParams(data!);
            getCmsSpecialFareOfferDetailAction.execute();
          }
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<void, void>({
        eventName: evtTree.CMSOffers.Detail.Back,
        handler: async () => {
          _eventBus.emit({
            eventName: "ROUTE_CHANGE",
            data: "/offers"
          });
        },
      })
    );
  }

  async onExecute(): Promise<void> {
    console.log("offer detail init step event setup");
  }
}

export const OfferDetailInitStepDeclaration = new StepDefinition({
  stepName: "OfferDetailInit_Step",
  stepClass: OfferDetailInitStep,
});
